module.exports = __webpack_public_path__ + "img/home.35ce64f9.svg";